const user = {
	name: 'User | Reporter',
	icon: 'fas fa-user',
	fields: {
		hp_id: 'ID',
		lastname: 'Person',
		email: 'Email',
		tos: 'Terms of Service',
		privacy: 'Privacy Policy',
		logins_count: 'Logins',
		welcome: 'Sent',
		created_at: 'Created',
		latest_login: {
			created_at: 'Last login',
		},
	},
}

export default user
